var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#CC8F0D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.75 23.5H26.25C25.5207 23.5 24.8212 23.7897 24.3055 24.3055C23.7897 24.8212 23.5 25.5207 23.5 26.25V53.75C23.5 54.4793 23.7897 55.1788 24.3055 55.6945C24.8212 56.2103 25.5207 56.5 26.25 56.5H44.9311C45.2924 56.5012 45.6503 56.4305 45.984 56.2921C46.3177 56.1537 46.6206 55.9504 46.875 55.6939L55.6939 46.875C55.9504 46.6206 56.1537 46.3177 56.2921 45.984C56.4305 45.6503 56.5012 45.2924 56.5 44.9311V26.25C56.5 25.5207 56.2103 24.8212 55.6945 24.3055C55.1788 23.7897 54.4793 23.5 53.75 23.5ZM26.25 26.25H53.75V44.125H45.5C45.1353 44.125 44.7856 44.2699 44.5277 44.5277C44.2699 44.7856 44.125 45.1353 44.125 45.5V53.75H26.25V26.25ZM51.8061 46.875L46.875 51.8061V46.875H51.8061Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.679e10050b371cdbce7dbf7314b8181e.svg";
export { ForwardRef as ReactComponent };